import React from "react"
import PropTypes from "prop-types"
import SuperEllipse from "react-superellipse";
import {Preset} from "react-superellipse";
class Squircle extends React.Component {
  render () {
    return (
      <React.Fragment>
        <SuperEllipse r1={0.03} r2={0.1} style={{width: this.props.width, height: this.props.height}}>
          <div dangerouslySetInnerHTML={{__html: this.props.html}} />
        </SuperEllipse>
      </React.Fragment>
    );
  }
}

Squircle.propTypes = {
  height: PropTypes.node,
  width: PropTypes.node,
  pic: PropTypes.node,
  html: PropTypes.node
};
export default Squircle
